import { render } from "./MessageEditForm.vue?vue&type=template&id=71645406"
import script from "./MessageEditForm.vue?vue&type=script&lang=js"
export * from "./MessageEditForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__